import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-12 px-4 bg-guarantee border-y border-amber-200" ref={ref} data-id="element-75">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-5" data-id="element-77">
          <ShieldCheckIcon className="w-20 h-20 text-accent-gold animate-pulse-glow" data-id="element-78" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-79">
          Garantía por Inconvenientes — 7 Días
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-slate-700 text-lg leading-[1.7] mb-5" data-id="element-80">
          Si en los primeros 7 días tenés algún inconveniente con el material,
          te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios
          complicados. Sin burocracia. Tu inversión está completamente
          protegida.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="inline-block bg-accent-gold text-white font-bold px-6 py-2 rounded-full mb-6 shadow-sm" data-id="element-81">
          ✅ Riesgo Cero — Tu dinero está protegido
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-82">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-accent-gold text-white font-bold text-lg py-4 px-10 rounded-xl hover:scale-[1.03] transition-transform duration-300 glow-gold" data-id="element-83">
            PROBALO SIN RIESGO — 7 DÍAS DE GARANTÍA →
          </button>
        </motion.div>
      </div>
    </section>;
}